var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state)?_c('div',{attrs:{"id":"App"}},[_c('MainHeader'),_c('main',{attrs:{"id":"MainBody"}},[_c('router-view')],1),_c('MainFooter')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }